import { EntityExistsResponseError, isEntityExistsResponse } from "@gtmhub/core/routing";
import { IEntity } from "@gtmhub/entities/models/models";
import { IHttpResponse } from "angular";
import { IDataSource, IDataSourcePatch } from "./models/models";

export const datasourceExistsErrorMessage = "datasource with this name already exists";

export enum DataSourceProperty {
  NAME = "name",
  SYNC_SCHEDULE = "syncSchedule",
  DESCRIPTION = "description",
  ALGORITHM = "algorithm",
  SYNC_CADENCE = "syncCadence",
}

export const isDataSourceChanged = (oldState: IDataSource, newState: IDataSource, propertyNames: DataSourceProperty[]): boolean => {
  if (oldState && newState) {
    for (const propertyName of propertyNames) {
      if (isDataSourcePropertyChanged(oldState, newState, propertyName)) {
        return true;
      }
    }
  }

  return false;
};

const isDataSourcePropertyChanged = (oldState: IDataSource, newState: IDataSource, propertyName: DataSourceProperty): boolean => {
  return !angular.equals(oldState[propertyName], newState[propertyName]);
};

export const getDataSourceChangedInfo = (oldState: IDataSource, newState: IDataSource, propertyNames: DataSourceProperty[]): IDataSourcePatch => {
  const dataSourceChangedInfo: IDataSourcePatch = {};
  if (oldState && newState) {
    propertyNames.forEach((propertyName) => {
      if (!isDataSourcePropertyChanged(oldState, newState, propertyName)) {
        return;
      }
      if (propertyName !== "syncCadence") {
        dataSourceChangedInfo[propertyName] = newState[propertyName];
        return;
      }
      if (newState.syncCadence && Object.keys(newState.syncCadence).length > 0) {
        dataSourceChangedInfo.syncCadence = newState.syncCadence;
      }
    });
    dataSourceChangedInfo.oldName = oldState.name;
  }

  return dataSourceChangedInfo;
};

export type DatasourceExistsError = EntityExistsResponseError & { data: IDataSource; error: "datasource with this name already exists" };
export type DefaultDatasourceEntityExistsError = EntityExistsResponseError & { data: IEntity; error: "the default datasource entity already exists" };

export const isDatasourceExistsResponse = (response: IHttpResponse<unknown>): response is IHttpResponse<DatasourceExistsError> => {
  if (!isEntityExistsResponse(response)) {
    return false;
  }
  return response.data.error === "datasource with this name already exists";
};

export const isDefaultDatasourceEntityExistsResponse = (response: IHttpResponse<unknown>): response is IHttpResponse<DefaultDatasourceEntityExistsError> => {
  if (!isEntityExistsResponse(response)) {
    return false;
  }
  return response.data.error === "the default datasource entity already exists";
};
